<template>
  <div class="container-fluid">
    <!-- Content Header (Page header) -->
   
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-12">
          <div class="box box-info">
            <div class="box-header with-border">
              
            </div>
            <div class="box-body">
              <div class="row">
                
                <div class="col-md-3">
                  <label for="date">Disbursement Date From</label>
                  <input type="date" v-model="form.disbursementStartDate" name="disbursementStartDate" class="form-control" @change="loadData" placeholder="Disbursment Start Date">
                </div>
                <div class="col-md-3">
                  <label for="date">Disbursement Date To</label>
                  <input type="date" v-model="form.disbursementEndDate" name="disbursementEndDate" class="form-control" @change="loadData" placeholder="Disbursment End Date">
                </div>
                <div class="col-md-3">
                  <label for="date">EMI End Date From</label>
                  <input type="date" v-model="form.startEmiEndDate" name="startEmiEndDate" class="form-control" @change="loadData" placeholder="Disbursment Start Date">
                </div>
                <div class="col-md-3">
                  <label for="date">EMI End Date To</label>
                  <input type="date" v-model="form.endtEmiEndDate" name="endEmiEndDate" class="form-control" @change="loadData" placeholder="Disbursment Start Date">
                </div>
                <div class="col-md-3">
                  <label for="date">Select Branch</label>
                  <select
                    v-model="form.branch_id"
                    name="branch_id"
                    @change="loadData"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('branch_id'),
                    }"
                    required
                  >
                    <option
                      v-if="!form.branch_id"
                      selected
                      value=""
                    >
                      Select Company Branch
                    </option>
                    <option
                      :value="branch.id"
                      v-for="branch in branches"
                      :key="branch.id"
                    >
                      {{ branch.name }}
                    </option>
                  </select>
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <div class="card">
            <div class="card-header">
              
              <span class="pull-right">
                <strong>Total amt: {{totalAmt}}</strong>
              </span>
              <h3 class="card-title">Loan Disbursed</h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-sm">
              <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed"
                :line-numbers="true"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true,
                  trigger: 'enter',
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'plan_name'">
                    {{ planName(props.row.plan) }}
                  </span>
                  <span v-if="props.column.field == 'plan_amt'">
                    {{ planAmt(props.row.plan) }}
                  </span>
                  <span v-if="props.column.field == 'total_amt'">
                    {{ totalGroupAmt(props.row) }}
                  </span>
                  <span v-if="props.column.field == 'DisbursementDate'">
                    {{props.row.disbursementDate | myDate}}
                  </span>
                  <span v-if="props.column.field == 'EmiStartDate'">
                    {{props.row.emiStartDate | myDate}}
                  </span>
                  <span v-if="props.column.field == 'EmiEndDate'">
                    {{props.row.emiEndDate | myDate}}
                  </span>
                  <span v-if="props.column.field == 'collection_Center'">
                    <button
                      v-if="props.row.collection_center"
                      @click="viewGroupMember(props.row.collection_center.id)"
                      class="btn btn-xs btn-info"
                    >
                      {{ props.row.collection_center.name }}
                    </button>
                  </span>
                  <span v-if="props.column.field == 'id'">
                    <button
                      v-if="canAccess('loan-disbursement-update')"
                      v-show="props.row.status == 'pending'"
                      @click="editModal(props.row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-delete')"
                      v-show="props.row.status == 'disbursed' || props.row.status == 'pending'"
                      @click="deleteDisbursment(props.row.id)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                    <button
                      v-show="props.row.filechargeStatus == 'exclude'"
                      @click="fileChargeModal(props.row)"
                      class="btn btn-warning btn-xs"
                      title="File Charge"
                    >
                      <i class="fa fa-file"></i>
                    </button>
                    <button
                      v-show="props.row.processingFeeStatus == 'exclude'"
                      @click="processingFeeModal(props.row)"
                      class="btn btn-warning btn-xs"
                      title="Processing Fee"
                    >
                      <i class="fa fa-hourglass"></i>
                    </button>
                    
                    <!-- <button
                      v-if="props.row.status == 'pending'"
                      @click="viewModal(props.row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-eye"></i>
                    </button> -->
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      
                      @click="viewPrintModal(props.row)"
                      title="For Staff"
                      class="btn btn-primary btn-xs"
                    >
                      <i class="fa fa-print"></i>
                    </button>
                    <button
                      v-if="canAccess('loan-disbursement-view')"
                      title="For Customer"
                      @click="viewPrintCustomerModal(props.row)"
                      class="btn btn-info btn-xs"
                    >
                      <i class="fa fa-hand-o-up"></i>
                    </button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
      
      <!-- /.modal -->
      <div class="modal fade" id="fileChargeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">File Charge</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect File Charge </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="processingFeeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Processing Fee Charge</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect Processing Fee </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewPrintModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button @click="print()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="print">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <table class="table table-condensed">
                        <thead>
                          <td width="18%"><img :src="logo" height="90"></td>
                          <td class="text-center" style="text-align:center;"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small></h4></td>
                          <td class="text-right" style="text-align:center;" width="20%"><barcode v-bind:value="seeRecord.member_loan_plan.applicationNo" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <hr width="100%">
                      <div v-if="seeRecord.status == 'disbursed'">
                      <table class="table table-condensed">
                        <thead>
                          <th colspan="2">Branch : {{seeRecord.branch.name}} ({{seeRecord.branch.branchCode}})</th>
                          
                          <th colspan="2" class="text-right">Date : {{seeRecord.created_at | myDate}}</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Customer Name </td><td> {{seeRecord.member.name}}</td>
                            <td rowspan="6" colspan="2">
                              <div style="border-width:3px;border-style:solid;width:150px;height:180px;float:right;text-align:center;"><br>Customer <br> & <br>Guarantor Photo <br>with Cross Sign</div>
                            </td>
                            
                          </tr>
                          <tr>
                            <td>Customer Code </td><td> {{seeRecord.member.code}}</td>
                          </tr>
                          <tr>
                            <td>Contact No </td><td> {{seeRecord.member.mobile}}</td>
                          </tr>
                          <tr>
                            <td>DOB </td><td> {{mem.dob | myDate}}</td>
                          </tr>
                          <tr>
                            <td>Gender </td><td> {{mem.gender}}</td>
                          </tr>
                          <tr>
                            <td>Spouse Name  </td><td> {{mem.spouseName}}</td>
                          </tr>
                          <tr>
                            <td>Father Name  </td><td> {{mem.fatherName}}</td>
                          </tr>
                          <tr>
                            <td>Mother Name  </td><td> {{mem.motherName}}</td>
                          </tr>
                          <tr>
                            <td colspan="2"><strong>Address Details</strong></td>
                            <td colspan="2"></td>
                          </tr>
                          <tr>
                            <td>Address </td><td> {{mem.address}}, {{mem.area}}</td>
                            <td>District/State/Pincode </td><td v-if="mem.state"> {{mem.district}}, {{mem.state.name}} - {{mem.pin}}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td colspan="2"><strong>Bank Details</strong></td>
                            <td colspan="2"><strong>Applied Loan Details</strong></td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td>Bank  </td><td><span v-if="mem.bank"> {{mem.bank.name}}</span></td>
                            
                            <!-- <td>Plan Name </td><td> {{pl.name}} <span class="text-right">Interest Rate  {{pl.interestRate}}</span></td> -->
                            <td>Loan ID </td><td> <span v-if="seeRecord.member_loan_plan" >{{seeRecord.member_loan_plan.applicationNo}}</span></td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td>Account Holder </td><td> {{mem.accountHolderName}}</td>
                            <td>File Charge </td><td v-if="seeRecord.fileCharge"> {{seeRecord.fileCharge}}</td><td v-else> {{pl.fileCharge}}</td>
                            <!-- <td>Insurance Charge </td><td v-if="seeRecord.fileCharge"> {{seeRecord.fileCharge}}</td><td v-else> {{pl.fileCharge}}</td> -->
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td>Account Number</td><td> {{mem.accountNumber}}</td>
                            <!-- <td>Income (INR) </td><td> {{mem.incomeAmount}}</td> -->
                            <!-- <td>Holiday Include </td><td> {{pl.holidayInclude}}</td> -->
                            <td><strong v-if="pl.rateOfInterest > 0">Interest Rate (%)</strong></td><td> <strong v-if="pl.rateOfInterest > 0">{{pl.rateOfInterest}}</strong></td>
                            <!-- <td>Interest Rate (%)</td><td> 22.7</td> -->
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td>IFSC </td><td> {{mem.ifsc}}</td>
                            <!-- <td>Income Type </td><td> {{mem.incomeType}}</td> -->
                            <td>Paid Amount </td><td v-if="seeRecord.loanAmount"> {{seeRecord.loanAmount}}</td><td v-else> {{pl.amount}}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td>Branch </td><td> {{mem.bankBranch}}</td>
                            <!-- <td>Minimum Income </td><td> {{mem.minAmount}}</td> -->
                            <td>Processing Fee <span v-if="pl.processingFeeType != 'fixed'">(%)</span> </td><td v-if="seeRecord.processingFee"> {{seeRecord.processingFee}}</td><td v-else> {{pl.processingFee}}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td colspan="2"><strong>Income Details</strong></td>
                            <td>No of Payments </td><td> {{pl.noOfPayments}}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td>Income (INR) </td><td> {{mem.incomeAmount}}</td>
                            <!-- <td>Business Address </td><td> {{mem.businessAddress}}</td> -->
                            <td>Plan Type </td><td> {{pl.planType}}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td>Occupation </td><td> {{mem.jobType}}</td>
                            <td>Plan Amount </td>
                            <td v-if="pl.planType === 'normalReduced' || pl.planType === 'special'">{{ showPlanAmtReduced(pl) }}</td>
                            <td v-else>{{ showPlanAmtNormal (pl) }}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td>Business Name </td><td> {{mem.businessName}}</td>
                            <td>Recovery type </td><td> {{pl.recoveryType}}</td>
                          </tr>
                          <tr>
                            <td colspan="2"><strong>Guarantor Details</strong></td>
                            <td>Plan Amount </td>
                            <td v-if="pl.planType === 'normalReduced'">{{ pl.amount + pl.fileCharge + pl.processingFee }}</td>
                            <td v-if="pl.planType != 'normalReduced'">{{ pl.amount + (pl.fileCharge) + (pl.amount * pl.processingFee)/100 }}</td>
                          </tr>
                          <tr>
                            <td>Name </td><td> {{mem.guarantorName}}</td>
                            <td>Recovery type </td><td> {{pl.recoveryType}}</td>
                          </tr>
                          <tr>
                            <td>Narration </td><td> {{mem.guarantorNarration}}</td>
                            <td>Type of Interest </td><td> {{pl.typeOfInterest}}</td>
                          </tr>
                          <tr>
                            <td>Address </td><td> {{mem.guarantorAddress}}</td>
                            <td>GST Include </td><td> {{pl.includeGst}}</td>
                          </tr>
                          <tr>
                            <td>Contact Number </td><td> {{mem.guarantorPhone}}</td>
                            <td colspan="2"></td>
                          </tr>
                          <tr>
                            <td><strong>Nominee Details</strong></td>
                            <td colspan="2"></td>
                          </tr>
                          <tr>
                            <td>Nominee Name </td><td> {{mem.nomineeName}}</td>
                            <td colspan="2"></td>
                          </tr>
                          <tr>
                            <td>Nomine Contact Number </td><td> {{mem.nomineePhone}}</td>
                            <td colspan="2"></td>
                          </tr>
                          <tr>
                            <td>Nominee Dob </td><td> {{mem.nomineeDob}}</td>
                            <td colspan="2"></td>
                          </tr>
                        </tbody>
                      </table>
                      <br><br>
                      <p>1.मैं /हम समझता हूं /समझते हैं की ऋण की कीमत में केवल दो गटक अथार्थ ब्याज प्रभार- प्रसंस्करण प्रभार शामिल
हैं।</p>
                      <p>2. मैं/ हम सहमत हूं /है और सहमति देता हूं/ देते हैं की एसमइग्रोथ माइक्रो को किसी भी बैंक कंपनी ट्रस्ट को ब्याज
सहित या उसके बिना ऋण बेचने का अधिकार है इसके अलावा एसमइग्रोथ को ऋण को सुरक्षित करने का अधिकार है और सभी
प्रक्रियाओं कर्जदार और जमानतदार दोनों के लिए लागू होगी।</p>
                      <p>3. मैं/ हम इस ऋण सुविधा के उद्देश्य से क्रेडिट ब्यूरो और बीमा कंपनी को अपना व्यक्तिगत विवरण शेयर करने के
लिए एस एममइग्रोथ माइक्रो फाउंडेशन से सहमत हूं/ है और अपनी सहमति प्रदान करता हूं /देते हैं।</p>
                      <p>4. यह है कि मुझसे कोई मार्जिन मनी या प्रतिभूति जमा नहीं लिया गया है।</p>
                      <p>5. मैंने/ हमने वित्त पोषण सुविधा जैसे हम /मैं एसमइग्रोथ माइक्रो से प्राप्त कर सकता हूं /सकते हैं पर लागू शुल्को और
प्रभारो को पढ़ और समझ लिया है।</p>
                      
                      <br>
                      <p class="text-center"><strong>घोषणा</strong></p>
                      <p>1. मैं /हम घोषणा और पुष्टि करता हूं/ करते हैं कि ऊपर वर्णित जानकारी मेरे /हमारे 
सर्वोत्तम ज्ञान के अनुसार सत्य और सही है और इसमें कुछ भी छुपाया नहीं गया है!
</p>
                      <p>2. मैं/ हम समझता हूं/ समझते हैं कि smeग्रोथ माइक्रो के पास ऋण आवेदन स्वीकार या अस्वीकार करने का पूर्ण विवेकाधिकार है!</p>
                      <p>3. मैं /हम ग्रामीण /शहरी क्षेत्र के निवासी हैं /हैं और हमारी घरेलू उपाय 100000 /170000से कम है!</p>
                      <p>4. मैं /हम एतदद्वारा मैं सच smeग्रोथ माइक्रो को मेरे/ हमारे केवाईसी विवरण लिपि बंद करने के लिए मेरी हमारी सहमति देता हूं/ देते हैं विवरण में किसी बदलाव के नाम लेने में ऐसी smeग्रोथ माइक्रो को नए विवरण अपडेट करूंगा!</p>
                      <p>5. समय कम 1 से अधिक एसएसजी (सेल्फ हेल्प ग्रुप) या जेएलजी (संयुक्त देयता समूह) के सदस्य नहीं है!</p>
                      <p>6. मैं /हम, केंद्र के सदस्य एतदद्वारा पुष्टि करते हैं कि फॉर्म में भरी गई विषय वस्तु मेरे /हमारे निर्देशों के अनुसार है और मुझे/हमें ज्ञात भाषा में पढ़ाई और समझाई गई है!</p>
                      <p><strong>Note</strong></p>
                      <p>A. ऋण अनुरोध की प्रक्रिया के लिए smeग्रोथ माइक्रो को 7-10दिन का समय लगेगा!</p>
                      <p>B. सदस्य अपने संबंधित आईडी नंबरों के साथ एक वैद्य फोटो आईडी और पता प्रमाण प्रस्तुत करेगा!</p>
                      <br>
                      <p><table class="table">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                            <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      <br><br><br><br><br><br><br><br><br><br>

                      </div>
                      <div v-if="seeRecord.status == 'pending'">
                        <br><br>
                        <table class="table" style="border-width:2px">
                          <thead style="border-width:2px">
                            <th style="border-width:2px">Application Date</th>
                            <th style="border-width:2px">Customer</th>
                            <th style="border-width:2px">Account Number</th>
                            <th style="border-width:2px">Guarantor Name</th>
                            <th style="border-width:2px">Plan Amount</th>
                            <th style="border-width:2px">Paid Amount</th>
                            <th v-show="pl.planType === 'normal'" style="border-width:2px">No. of EMI</th>
                          </thead>
                          <tbody style="border-width:2px">
                            <td style="border-width:2px">{{seeRecord.disbursementDate | myDate}}</td>
                            <td style="border-width:2px">{{seeRecord.member.name}} ({{seeRecord.member.code}})</td>
                            <td style="border-width:2px">{{mem.accountNumber}}</td>
                            <td style="border-width:2px">{{mem.guarantorName}}</td>
                            <td style="border-width:2px" v-if="pl.planType === 'normalReduced'">{{ pl.amount + pl.fileCharge + pl.processingFee }}</td>
                            <td style="border-width:2px" v-if="pl.planType != 'normalReduced'">{{ pl.amount + (pl.fileCharge) + (pl.amount * pl.processingFee)/100 }}</td>
                            <td style="border-width:2px" >{{pl.amount}}</td>
                            <td style="border-width:2px" v-show="pl.planType === 'normal'">{{pl.noOfPayments}}</td>
                          </tbody>
                        </table>
                        <br><br>
                        <table class="table" v-if="seeRecord.status == 'pending'">
                          <thead>
                            <th>Branch Manager Signature</th>
                            <th>Customer Signature</th>
                            <th>Date</th>
                          </thead>
                        </table>
                        <br><br>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewPrintCustomerModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button @click="printCustomer()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printCustomer">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <table class="table table-condensed">
                        <thead>
                          <td width="18%"><img :src="logo" height="90"></td>
                          <td style="text-align:center;" class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small></h4></td>
                          <td style="text-align:center;" class="text-right" width="20%"><barcode v-bind:value="seeRecord.member_loan_plan.applicationNo" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <hr width="100%">
                      <div v-if="seeRecord.status == 'disbursed'">
                      <table class="table table-condensed">
                        <thead>
                          <th colspan="2">Branch : {{seeRecord.branch.name}} ({{seeRecord.branch.branchCode}})</th>
                          
                          <th colspan="2" class="text-right">Disbursment Date : {{seeRecord.disbursementDate | myDate}}</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="border-width:2px">Customer Name </td><td style="border-width:2px"> {{seeRecord.member.name}} - {{seeRecord.member.code}}</td>
                            <td style="border-width:2px" rowspan="5" colspan="2">
                              <div style="border-width:3px;border-style:solid;width:150px;height:180px;float:right;text-align:center;"><br>Customer <br> & <br>Guarantor Photo <br>with Cross Sign</div>
                            </td>
                            
                          </tr>
                          
                          <tr>
                            <td style="border-width:2px">Contact No </td><td style="border-width:2px"> {{seeRecord.member.mobile}}</td>
                          </tr>
                          <tr>
                            <td style="border-width:2px">Adhar Number </td><td style="border-width:2px"> {{adhar}}</td>
                          </tr>
                          <tr>
                            <td style="border-width:2px">Gender </td><td style="border-width:2px"> {{mem.gender}}</td>
                          </tr>
                          <tr>
                            <td style="border-width:2px">Spouse Name  </td><td style="border-width:2px"> {{mem.spouseName}}</td>
                          </tr>
                          <tr>
                            <td style="border-width:2px">Father Name  </td><td style="border-width:2px"> {{mem.fatherName}}</td>
                            <td style="border-width:2px">Account Number</td>
                            <td style="border-width:2px">{{mem.accountNumber}}</td>
                          </tr>
                          
                          <tr>
                            <td style="border-width:2px" colspan="2"><strong>Address Details</strong></td>
                            <td style="border-width:2px" colspan="2"></td>
                          </tr>
                          <tr>
                            <td style="border-width:2px">Address </td><td style="border-width:2px"> {{mem.address}}, {{mem.area}}</td>
                            <td style="border-width:2px">District/State/Pincode </td><td style="border-width:2px" v-if="mem.state"> {{mem.district}}, {{mem.state.name}} - {{mem.pin}}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px" colspan="2"><strong>Bank Details</strong></td>
                            <td style="border-width:2px" colspan="2"><strong>Applied Loan Details</strong></td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px">Bank  </td><td style="border-width:2px"><span v-if="mem.bank"> {{mem.bank.name}}</span></td>
                            
                            <!-- <td style="border-width:2px">Plan Name </td><td style="border-width:2px"> {{pl.name}} <span class="text-right">Interest Rate  {{pl.interestRate}}</span></td> -->
                            <td style="border-width:2px">Loan ID </td><td style="border-width:2px"> <span v-if="seeRecord.member_loan_plan" >{{seeRecord.member_loan_plan.applicationNo}}</span></td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px">Account Holder </td><td style="border-width:2px"> {{mem.accountHolderName}}</td>
                            <td style="border-width:2px">File Charge </td><td style="border-width:2px" v-if="seeRecord.fileCharge"> {{seeRecord.fileCharge}}</td><td style="border-width:2px" v-else> {{pl.fileCharge}}</td>
                            <!-- <td style="border-width:2px">Insurance Charge </td><td style="border-width:2px" v-if="seeRecord.fileCharge"> {{seeRecord.fileCharge}}</td><td style="border-width:2px" v-else> {{pl.fileCharge}}</td> -->
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px">Account Number</td><td style="border-width:2px"> {{mem.accountNumber}}</td>
                            <!-- <td style="border-width:2px">Income (INR) </td><td style="border-width:2px"> {{mem.incomeAmount}}</td> -->
                            <!-- <td style="border-width:2px">Holiday Include </td><td style="border-width:2px"> {{pl.holidayInclude}}</td> -->
                            <td style="border-width:2px"><strong v-if="pl.rateOfInterest > 0">Interest Rate (%)</strong></td><td style="border-width:2px"><strong v-if="pl.rateOfInterest > 0"> {{pl.rateOfInterest}}</strong></td>
                            <!-- <td style="border-width:2px">Interest Rate (%)</td><td style="border-width:2px"> 22.7</td> -->
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px">IFSC </td><td style="border-width:2px"> {{mem.ifsc}}</td>
                            <!-- <td style="border-width:2px">Income Type </td><td style="border-width:2px"> {{mem.incomeType}}</td> -->
                            <td style="border-width:2px">Paid Amount </td><td style="border-width:2px" v-if="seeRecord.loanAmount"> {{seeRecord.loanAmount}}</td><td style="border-width:2px" v-else> {{pl.amount}}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px">Branch </td><td style="border-width:2px"> {{mem.bankBranch}}</td>
                            <!-- <td style="border-width:2px">Minimum Income </td><td style="border-width:2px"> {{mem.minAmount}}</td> -->
                            <td style="border-width:2px">Processing Fee <span v-if="pl.processingFeeType != 'fixed'">(%)</span> </td><td style="border-width:2px" v-if="seeRecord.processingFee"> {{seeRecord.processingFee}}</td><td style="border-width:2px" v-else> {{pl.processingFee}}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px" colspan="2"><strong>Income Details</strong></td>
                            <td style="border-width:2px">No of Payments </td><td style="border-width:2px"> {{pl.noOfPayments}}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px">Income (INR) </td><td style="border-width:2px"> {{mem.incomeAmount}}</td>
                            <!-- <td style="border-width:2px">Business Address </td><td style="border-width:2px"> {{mem.businessAddress}}</td> -->
                            <td style="border-width:2px">Plan Type </td><td style="border-width:2px"> {{pl.planType}}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px">Occupation </td><td style="border-width:2px"> {{mem.jobType}}</td>
                            <td style="border-width:2px">Plan Amount </td>
                            <td style="border-width:2px" v-if="pl.planType === 'normalReduced' || pl.planType === 'special'">{{ showPlanAmtReduced(pl) }}</td>
                            <td style="border-width:2px" v-else>{{ showPlanAmtNormal (pl) }}</td>
                          </tr>
                          <tr style="border-width:2px;border-style:solid;">
                            <td style="border-width:2px">Business Name </td><td style="border-width:2px"> {{mem.businessName}}</td>
                            <td style="border-width:2px">Recovery type </td><td style="border-width:2px"> {{pl.recoveryType}}</td>
                          </tr>
                          <tr>
                            <td style="border-width:2px" colspan="2"><strong>Guarantor Details</strong></td>
                            <td style="border-width:2px" colspan="2"><strong>Applied Loan Details</strong></td>
                          </tr>
                          <tr>
                            <td style="border-width:2px">Name </td><td style="border-width:2px"> {{mem.guarantorName}}</td>
                            <td style="border-width:2px">Plan Amount </td>
                            <td style="border-width:2px" v-if="pl.planType === 'normalReduced'">{{ pl.amount + pl.fileCharge + pl.processingFee }}</td>
                            <td style="border-width:2px" v-if="pl.planType != 'normalReduced'">{{ pl.amount + (pl.fileCharge) + (pl.amount * pl.processingFee)/100 }}</td>
                          </tr>
                          
                          <tr>
                            <td style="border-width:2px">Address </td><td style="border-width:2px"> {{mem.guarantorAddress}}</td>
                            <td style="border-width:2px">Paid Amount </td><td style="border-width:2px"> {{pl.amount}}</td>
                          </tr>
                          
                          <tr>
                            <td style="border-width:2px">Contact Number </td><td style="border-width:2px"> {{mem.guarantorPhone}}</td>
                            <td style="border-width:2px">No of EMI </td><td style="border-width:2px"> {{pl.noOfPayments}}</td>
                          </tr>
                          
                        </tbody>
                      </table>
                     
                      </div>
                      
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Loan Details</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row">
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul
                        class="list-group list-group-unbordered mb-3"
                        v-if="seeRecord.branch"
                      >
                        <li class="list-group-item">
                          <b>Branch Name</b>

                          <a class="pull-right">{{ seeRecord.branch.name }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Branch Code</b>
                          <a class="pull-right">{{
                            seeRecord.branch.branchCode
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Agent Name</b>
                          <a class="pull-right">{{ seeRecord.agent.name }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Agent Code</b>
                          <a class="pull-right">{{ seeRecord.agent.code }}</a>
                        </li>

                        <li class="list-group-item">
                          <b>Plan Details</b>
                          <table
                            class="table table-sm table-striped table-dark"
                          >
                            <tr>
                              <td><b>Plan Name </b> : {{ pl.name }}</td>
                              <td><b>Plan Type </b> : {{ pl.planType }}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>Type of Interest</b> : {{ pl.typeOfInterest }}
                              </td>
                              <td>
                                <!-- <b>Tenure </b>: Year - {{ pl.tenureYear }},
                                Month - {{ pl.tenureMonth }}, Day -
                                {{ pl.tenureDay }} -->
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <b>Recovery Type</b> : {{ pl.recoveryType }}
                              </td>
                              <td>
                                <b>Number of Payments</b> :
                                {{ pl.noOfPayments }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>Amount</b> : {{ pl.amount }}</td>
                              <td>
                                <b>Advance Installment</b> :
                                {{ pl.acvanceInstallment }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>Panulty </b>: {{ pl.panulty }}</td>
                              <td>
                                <b>Processing Fee </b>: {{ pl.processingFee }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>File Charge</b> : {{ pl.fileCharge }}</td>
                              <td>
                                <b>Created By</b> : {{ pl.created_by.name }}
                              </td>
                            </tr>
                          </table>
                        </li>
                        <li class="list-group-item" v-if="seeRecord.member_id">
                          <b>Member Name</b>
                          <a class="pull-right">{{ seeRecord.member.name }}</a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul
                        class="list-group list-group-unbordered mb-3"
                        v-if="seeRecord.branch"
                      >
                        <li class="list-group-item">
                          <b>Plan Type</b>
                          <a class="pull-right">{{ seeRecord.planType }}</a>
                        </li>

                        <li class="list-group-item" v-if="seeRecord.collection_center">
                          <b>Group Name</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center.name
                          }}</a>
                        </li>
                        <li class="list-group-item" v-if="seeRecord.collection_center">
                          <b>Group Code</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center.centerCode
                          }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="seeRecord.collection_center_leader"
                        >
                          <b>Group Leader</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center_leader.name
                          }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="seeRecord.collection_center_leader"
                        >
                          <b>Group Leader Code</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center_leader.code
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Disbursement Date</b>
                          <a class="pull-right">{{
                            seeRecord.disbursementDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>EMI Start Date</b>
                          <a class="pull-right">{{
                            seeRecord.emiStartDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Payment Mode</b>
                          <a class="pull-right">{{ seeRecord.paymentMode }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Status</b>
                          <a class="pull-right">{{ seeRecord.status }}</a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewGroupMember">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Group Member Details</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row">
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul class="list-group list-group-unbordered mb-3">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Code</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="groupMem in groupMembers"
                              :key="groupMem.id"
                            >
                              <td>
                                <a>{{ groupMem.member.name }}</a>
                              </td>
                              <td>
                                <a> {{ groupMem.member.code }}</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode'
export default {
  name: 'my-component',
  data () {
    return {
      totalAmt: 0,
      editMode: false,
      logo: '',
      adhar: '',
      mem: {},
      collectionCenters: {},
      colC: {},
      branches: [],
      branch: {},
      members: [],
      staffs: {},
      bank_accounts: [],
      pl: {},
      seeRecord: {},
      loanplans: [],
      groupMembers: {},
      getCompanyRecord: {},
      viewCollectionCenter: '',
      form: new Form({
        id: '',
        collection_center_id: '',
        member_id: '',
        branch_id: '',
        agent_id: '',
        center_leader_id: '',
        plan_id: '',
        plan: {},
        planType: 'individual',
        status: '',
        branch_ledger_id: '',
        disbursement_id: '',
        disbursementStartDate: '',
        disbursementEndDate: '',
        startEmiEndDate: '',
        endEmiEndDate: '',
        emiStartDate: '',
        processingFee: null,
        insuranceFee: null,
        fileCharge: null,
        amt: '',
        type: '',
        paymentDate: null
      }),
      columns: [
        {
          label: 'PLAN Name',
          field: 'plan_name'
        },
        {
          label: 'Plan Amount',
          field: 'plan_amt'
        },
        {
          label: 'Dis. Date',
          field: 'DisbursementDate'
        },
        {
          label: 'EMI Start Date',
          field: 'EmiStartDate'
        },
        {
          label: 'EMI End Date',
          field: 'EmiEndDate'
        },
        {
          label: 'GROUP',
          field: 'collection_Center'
        },
        {
          label: 'AGENT',
          field: 'agent.name'
        },
        {
          label: 'MODE',
          field: 'branch_ledger.ledger.name'
        },
        {
          label: 'CENTER LEADER',
          field: 'collection_center_leader.name'
        },
        {
          label: 'ACTIONS',
          field: 'id',
          type: 'number'
        }
      ],
      rows: []
    }
  },
  components: {
    'barcode': VueBarcode
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    planName (plan) {
      var pln = JSON.parse(plan)
      return pln.name
    },
    planAmt (plan) {
      var pln = JSON.parse(plan)
      return pln.amount
    },
    viewPrintModal (row) {
      this.form.reset()
      this.loadCompanyProfile()
      $('#viewPrintModal').modal('show')
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    viewPrintCustomerModal (row) {
      this.form.reset()
      this.loadCompanyProfile()
      $('#viewPrintCustomerModal').modal('show')
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
          this.adhar = this.mem.aadharNo.replace(/\d(?=\d{4})/g, '*')
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    deleteDisbursment (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .delete('disbursement/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    viewModal (row) {
      this.form.reset()
      $('#viewModal').modal('show')
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
    },
    viewGroupMember (id) {
      this.loadGroupMember(id)
      $('#viewGroupMember').modal('show')
      // this.viewCollectionCenter = collection_center.id
      // console.log(collection_center.id)
    },
    getBranchMember () {
      this.form.member_id = this.mem.user_id
    },
    getBranchCollectionCenter () {
      this.form.collection_center_id = this.colC.id
      this.loadGroupMember(this.form.collection_center_id)
    },
    // processingFeeCollect () {
    //   if (this.form.planType === 'individual') {
    //     this.$delete(this.form, 'collection_center_id')
    //     this.$delete(this.form, 'center_leader_id')
    //   }
    //   this.$axios
    //     .post('membercollection', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then(() => {
    //       Fire.$emit('AfterCreate')
    //       $('#processingFeeModal').modal('hide')
    //       Toast.fire({
    //         icon: 'success',
    //         title: 'Processing Fee Paid Successfully'
    //       })
    //     })
    // },

    fileChargeProcessingFeeCollect () {
      if (this.form.planType === 'individual') {
        this.$delete(this.form, 'collection_center_id')
        this.$delete(this.form, 'center_leader_id')
      }
      this.$axios
        .post('membercollection', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          this.form.disbursementStartDate = ''
          this.form.disbursementEndDate = ''
          this.form.startEmiEndDate = ''
          this.form.endEmiEndDate = ''
          this.form.branch_id = ''
          this.loadData()
          if (this.form.type === 'fileCharge') {
            $('#fileChargeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'File Charge Paid Successfully'
            })
          }
          if (this.form.type === 'processingFee') {
            $('#processingFeeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'Processing Fee Paid Successfully'
            })
          }
          $('#fileChargeModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'File Charge Paid Successfully'
          })
        })
    },
    fileChargeModal (row) {
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#fileChargeModal').modal('show')
      this.form.fill(row)
      this.form.type = 'fileCharge'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      this.form.amt = this.pl.fileCharge
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    processingFeeModal (row) {
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#processingFeeModal').modal('show')
      this.form.fill(row)
      this.form.type = 'processingFee'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.processingFeeType === 'percent') {
        this.form.amt = this.pl.processingFee * this.pl.amount / 100
      }
      if (this.pl.processingFeeType === 'fixed') {
        this.form.amt = this.pl.processingFee
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    getBranchBankAccount (id) {
      this.$axios
        .get('branchledger?all=all&multiple_group_id[]=1&multiple_group_id[]=2&multiple_group_id[]=4&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.bank_accounts = data.data
          $.each(this.bank_accounts, function (key, value) {
            this.bank_accounts[key].name = value.ledger.name
          }.bind(this))
        }).catch(function (error) { console.log(error) })
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$axios
            .delete('collectioncentermember/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')

              Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
            })
            .catch(() => {
              Swal.fire('Failed!', 'There was something wrong.', 'error')
            })
        }
      })
    },
    getSelectPlan () {
      // alert(this.form.plan.id)
      this.form.plan_id = this.form.plan.id
    },
    getPlanType () {
      this.form.center_leader_id = null
      this.form.collection_center_id = null
      this.form.member_id = null
    },
    loadStaff () {
      this.$axios
        .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadBranch () {
      this.$axios
        .get('branch?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadLoan () {
      this.$axios
        .get('loanplan?all=all&status=true', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.loanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadGroupMember (id) {
      this.$axios
        .get('collectioncentermember?all=all&collection_center_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.groupMembers = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    print () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('print').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    },
    printCustomer () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printCustomer').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    },
    loadData () {
      let loader = this.$loading.show()
      this.totalAmt = 0
      this.$axios
        .get('disbursement?all=all&status=disbursed&searchTerm=group&disbursementStartDate=' + this.form.disbursementStartDate + '&disbursementEndDate=' + this.form.disbursementEndDate + '&startEmiEndDate=' + this.form.startEmiEndDate + '&endEmiEndDate=' + this.form.endEmiEndDate + '&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.rows = data.data
          _.forEach(this.rows, function (row, key) {
            this.totalAmt += JSON.parse(row.plan).amount
          }.bind(this))
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },

  created () {
    // this.loadMember()

    this.loadData()
    this.loadBranch()
    this.loadLoan()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>
<style scoped>
  @media print {
      .modal {
          position: absolute;
          left: 0;
          top: 0;
          margin: 0;
          padding: 0;
          overflow: visible!important;
      }
  }
  table.vgt-table {
  font-size:10px !important;
  border-collapse:collapse;
  background-color:#fff;
  width:100%;
  max-width:100%;
  table-layout:auto;
  border:1px solid #dcdfe6
  }
  .list-group-item {
    background-color: antiquewhite;
  }
  .content {
    padding: 0px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// GroupDisbursment.vue?56927dbe